export default "__VITE_ASSET__0FjG37yk__"